import styled from 'styled-components';

const H1 = styled.h1`
  font-size: 2.438rem;
  line-height: 134.6%;
  margin-bottom: 0.25em;
`;

export default H1;
